import { Box, Button, MenuItem, TextField, Typography } from "@mui/material"
import { useContext, useState } from "react"
import { updateQuestion } from "../axios/axiosFunctions";
import { AssessmentContext } from "../contexts/assessments";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';

const QuestionElement = ({text,qId,typeQ}) => {

    const [editMode, setEditMode] = useState(false);
    const [newQuestion, setNewQuestion] = useState(text);
    const [newType, setNewType] = useState(typeQ || "mo");
    const [showIcon, setShowIcon] = useState(false);
    const [saved, setSaved] = useState(true);
    const {refetchAssessments} = useContext(AssessmentContext);

    const handleEditMode = ()=>{
        // reset edits to the persisted values whenever we toggle the editor
        setNewQuestion(text);
        setNewType(typeQ || "mo");
        setEditMode(!editMode);
    }

    const handleChange = (e)=>{
        const {value} = e.target;
        setNewQuestion(value);
    }

    const handleSave = async()=>{

        const data={
            text: newQuestion,
            typeQ: newType,
        }

        const res = await updateQuestion(qId,data);
        if(!res){
            setSaved(false);
        }

        await refetchAssessments();
        setEditMode(false);
        setShowIcon(true);
        setTimeout(() => {
            setShowIcon(false);
            setSaved(true);
        }, 1000);

    }

    return (
    <Box sx={{backgroundColor:"white",padding:"20px",borderRadius:"5px",display:"flex",marginBottom:"10px",justifyContent:"space-between",alignItems:"center",gap:"12px"}}>
        {
            editMode && <>
                <TextField onChange={handleChange} fullWidth multiline value={newQuestion} color="primary"/>
                <TextField select value={newType} onChange={(e)=>setNewType(e.target.value)} sx={{minWidth:"180px"}}>
                    <MenuItem value="mo">Multiple choice</MenuItem>
                    <MenuItem value="op">Open-ended</MenuItem>
                </TextField>
                <Button onClick={handleSave} color="secondary"><span className="underline-blue">Save</span></Button>
                <Button onClick={handleEditMode} color="secondary"><span className="underline-blue">Cancel</span></Button>
            </>
        }
        {
            !editMode && <>
                <Box>
                    <Typography variant="subtitle1">{text}</Typography>
                    {
                        (typeQ || "mo") === "op" &&
                        <Typography variant="caption" color="text.secondary">Open-ended</Typography>
                    }
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                    {
                        showIcon && <>
                        {
                            saved ? <CheckCircleIcon sx={{color:"green"}}/> : <ClearIcon sx={{color:"red"}}/>
                        }
                        </>
                    }
                    <Button onClick={handleEditMode} color="secondary"><span className="underline-blue">Edit</span></Button>
                </Box>
            </>
        }
    </Box>
    )
}

export default QuestionElement
